theme.headerSection = (function () {
  function header() {
    const offcanvasHeader = function () {
      const offcanvasOpen = document.querySelector(".header__actions_btn--menu"),
        offcanvasClose = document.querySelector(".offcanvas__close_btn"),
        offcanvasHeaderEl = document.querySelector(".offcanvas-header"),
        offcanvasMenu = document.querySelectorAll(".offcanvas__menu"),
        body = document.querySelector("body");

      function resetOffcanvasBranch(li) {
        if (!li) return;
        li.classList.remove("active");
        li.querySelectorAll("li.active").forEach(function (el) {
          el.classList.remove("active");
        });
        li.querySelectorAll(".offcanvas__accordion_toggle").forEach(function (b) {
          b.classList.remove("active");
          b.setAttribute("aria-expanded", "false");
        });
        li.querySelectorAll(".offcanvas__sub_menu").forEach(function (sub) {
          slideUp(sub);
        });
      }

      offcanvasMenu.forEach(function (menu) {
        menu.querySelectorAll(".offcanvas__accordion_toggle").forEach(function (toggle) {
          toggle.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            const submenuId = toggle.getAttribute("aria-controls");
            const submenu = submenuId ? document.getElementById(submenuId) : null;
            if (!submenu) return;

            const item = toggle.closest(".offcanvas__menu_li, .offcanvas__sub_menu_li");
            if (!item || !menu.contains(item)) return;

            const isOpen = item.classList.contains("active");

            if (isOpen) {
              item.classList.remove("active");
              toggle.classList.remove("active");
              toggle.setAttribute("aria-expanded", "false");
              slideUp(submenu);
            } else {
              getSiblings(item).forEach(function (sib) {
                if (sib.nodeType === 1) resetOffcanvasBranch(sib);
              });
              item.classList.add("active");
              toggle.classList.add("active");
              toggle.setAttribute("aria-expanded", "true");
              slideDown(submenu);
            }
          });
        });

        // Make parent rows behave like accordion headers on mobile.
        menu.querySelectorAll(".offcanvas__menu_row, .offcanvas__sub_menu_row").forEach(function (row) {
          row.addEventListener("click", function (e) {
            const toggle = row.querySelector(".offcanvas__accordion_toggle");
            if (!toggle) return;

            e.preventDefault();
            e.stopPropagation();
            toggle.click();
          });
        });
      });

      if (offcanvasOpen && offcanvasHeaderEl) {
        offcanvasOpen.addEventListener("click", function (e) {
          e.preventDefault();
          offcanvasHeaderEl.classList.add("open");
          body.style.overflowY = "hidden";
        });
      }
      if (offcanvasClose && offcanvasHeaderEl) {
        offcanvasClose.addEventListener("click", function (e) {
          e.preventDefault();
          offcanvasHeaderEl.classList.remove("open");
          body.style.overflowY = null;
        });
      }

      document.addEventListener("click", function (event) {
        if (
          !event.target.closest(".header__actions_btn--menu") &&
          !event.target.classList.contains("header__actions_btn--menu")
        ) {
          if (
            !event.target.closest(".offcanvas-header") &&
            !event.target.classList.contains("offcanvas-header")
          ) {
            if (offcanvasHeaderEl) {
              offcanvasHeaderEl.classList.remove("open");
              body.style.overflowY = null;
            }
          }
        }
      });

      window.addEventListener("resize", function () {
        if (window.outerWidth >= 992 && offcanvasHeaderEl) {
          offcanvasHeaderEl.classList.remove("open");
          body.style.overflowY = null;
        }
      });
    };
    offcanvasHeader();
  }

  return header;
})();
